import { useState, useEffect} from "react";
import '../App.css';
import '../styles.css';
import { useChat } from "../contexts/ChatProvider";
import {WidgetContainer} from "../components/WidgetContainer";
import {nanoid} from "nanoid";
import '../url-search-params-polyfill'; // Import the polyfill
import { getLocaleFromQuery } from "../utils/getLocaleFromQuery";

function App() {
  const {
    sendMessage,
    setCustomTheme,
    setCustomColorSet,
    fetchConversations,
    messages,
    loadConversation,
    setLoadConversation,
    setGreeting,
    setClientKey,
    setDataPrefix,
    setHeader,
    updateIdentity,
    setMemberId,
    setIsMobile,
    setEnableFeedbackData,
    setNegFeedbackOptions,
    setPosFeedbackOptions,
    setPosFeedbackSuccessMessage,
    setNegFeedbackSuccessMessage,
    sessionId,
    setWidgetLanguage,
    setDisableUrlPattern,
    setDisableAfterMS
  } = useChat();
  const [license, setLicense] = useState("");
  const invalid = [undefined, null, "", "null", "undefined"];


  useEffect( () => {
    // Signal that the content is ready
    window.parent.postMessage({ type: 'contentReady' }, '*');
    window.parent.postMessage({ type:"isMobile" }, "*")
    const urlParams = new URLSearchParams( window.location.search);
    const clientKey = urlParams.get("clientKey");
    setClientKey(clientKey);
    const dataPrefix = urlParams.get("dataPrefix");
    setDataPrefix(dataPrefix);
    const header = urlParams.get("chatHeader");
    setHeader(header);
    const feedbackPermission =  urlParams.get("enableFeedback");
    setEnableFeedbackData(feedbackPermission);
    const license = urlParams.get("license");
    const commonPositiveFeedbackOptions = urlParams.get("posFeedbackOptions");
    const commonNegativeFeedbackOptions = urlParams.get("negFeedbackOptions");
    const posFbSuccessMsg = urlParams.get("posFbSuccessMsg");
    const negFbSuccessMsg = urlParams.get("negFbSuccessMsg");
    setPosFeedbackSuccessMessage( posFbSuccessMsg != "null" ? posFbSuccessMsg : "");
    setNegFeedbackSuccessMessage(negFbSuccessMsg != "null" ? negFbSuccessMsg : "");
    setWidgetLanguage(getLocaleFromQuery());

    const disableUrlPattern = urlParams.get("disableURLPattern");
    const disableAfterHour = Number(urlParams.get("disableAfterHour"));

    if(!invalid.includes(disableUrlPattern)){
      setDisableUrlPattern(disableUrlPattern);
    }
    if (Number.isFinite(disableAfterHour) && disableAfterHour > 0) {
      setDisableAfterMS(disableAfterHour * 60 * 60 * 1000);
    }

    try {
      const options = JSON.parse(commonPositiveFeedbackOptions);
      setPosFeedbackOptions(Array.isArray(options) ? options : []);
    } catch (err) {
      console.error('Failed to parse data-common-positive-feedback-options:', err);
    }
    try {
      const options = JSON.parse(commonNegativeFeedbackOptions);
      setNegFeedbackOptions(Array.isArray(options) ? options : []);
    } catch (err) {
      console.error('Failed to parse data-common-negative-feedback-options:', err);
    }
    setLicense(license);
  },[]);

  useEffect(() => {
    const handleMessage = evt => {
      if(evt.data.theme ) {
        setCustomTheme(evt.data.theme);
      }
      if(evt.data.updateConfig ) {
        if(evt.data.updateConfig.theme){
          setCustomTheme(evt.data.updateConfig.theme);
        }
        if(evt.data.updateConfig.colorSet){
          setCustomColorSet(evt.data.updateConfig.colorSet);
        }
      }

      if(evt.data.updateIds) {
        const nextUserId = evt.data.updateIds.userId ? String(evt.data.updateIds.userId) : null;
        const nextMemberId = evt.data.updateIds.memberId ? String(evt.data.updateIds.memberId) : null;
        updateIdentity(nextUserId);
        if (nextMemberId) setMemberId(nextMemberId);
        window.parent.postMessage({ type: 'updateIdsOk' }, '*');
      }
      else if(evt.data.greeting) {
        setGreeting(evt.data.greeting);
      }
      else if(evt.data.load){
        if(!loadConversation){
          setLoadConversation(true);
        }
      } 
      else if(evt.data.sendMessage) {
        sendMessage({
          _id: nanoid(),
          text: evt.data.sendMessage,
          session_id: sessionId,
          user: "remote",
          type: "outgoing",
        });
      }
      if(evt.data.type === "viewport-size") {
        setIsMobile(evt.data.deviceType == "mobile")
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);

  },[setGreeting, sendMessage, setCustomTheme, setCustomColorSet, fetchConversations, updateIdentity, setMemberId]);

  return (
      <WidgetContainer license={license}/>
  );
}

export default App;